export default function hostingPackage(hostingPackage, name, features, icon) {
  return {
    id: hostingPackage.name,
    name: name,
    icon: icon,
    features: features,
    price: hostingPackage.firstYearPriceAsText,
    price1styear: hostingPackage.displayPriceAsNumber,
    originalPrice: hostingPackage.renewalPriceAsText,
    isFree: true, // TODO: Add this
    currency: hostingPackage.currency,
    hasRebate:
      hostingPackage.displayPriceAsNumber !==
      hostingPackage.originalDisplayPriceAsNumber,
    type: "package",
    discountPercentage: hostingPackage.effectiveDiscountPercentage,
  };
}

/*

currency: "DKK"
displayPriceAsNumber: 7.6
fullDisplayPrice: "<span class="price">9,50</span> <span class="currency">kr.</span> <span class="monthly">/mo.</span>"
fullOriginalDisplayPrice: "Renews at <span class="price">9,50</span> <span class="currency">kr.</span>"
name: "domain"
originalDisplayPriceAsNumber: 7.6
packageName: "Domain"

*/
